import classes from '@/components/Form/Confirmation/Confirmation.module.scss';
import type { FormField } from '@/components/Form/helper/formHelper';
import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import { truncateFileName } from '@/helper/text';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IConfirmation {
  submittedValues: FormField[];
  invisibleFields: string[];
}

const Confirmation: FC<IConfirmation> = ({ submittedValues, invisibleFields }) => {
  const { t } = useTranslation();
  return (
    <div>
      <HeadlineField tag={HeadlineTag.H3} style={HeadlineTag.H6} className={classes.confirmationTitle}>
        {t('Zusammenfassung')}
      </HeadlineField>
      {!!submittedValues &&
        submittedValues.map((field: FormField, index: number) => {
          if (
            !field.fieldValue ||
            field.fieldValue === 'undefined' ||
            field.hiddenField ||
            invisibleFields.includes(field.fieldId)
          ) {
            return null;
          }
          return (
            <dl className={classes.field} key={`form-${index}`}>
              <dt className={classes.key}>{field.fieldLabel}</dt>
              <dd
                className={
                  field.fieldType === 'FormTextarea' ? `${classes.value} ${classes.textareaValue}` : classes.value
                }
              >
                {Array.isArray(field.fieldValue) ? (
                  field.fieldValue.map((file, fileIndex: number) => (
                    <div key={`file-${fileIndex}`}>{truncateFileName(file.name)}</div>
                  ))
                ) : field.fieldType === 'FormCheckbox' ? (
                  <ul className={classes.checkboxValues}>
                    {(field.fieldValueLabels ?? [field.fieldValueLabel || field.fieldValue]).map(
                      (option, optionIndex) => (
                        <li key={`${field.fieldId}-${optionIndex}`}>{option}</li>
                      )
                    )}
                  </ul>
                ) : (
                  field.fieldValueLabel || field.fieldValue
                )}
              </dd>
            </dl>
          );
        })}
    </div>
  );
};

export default Confirmation;
